import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from 'environments/environment';
import { InnovationType } from "../models";

@Injectable({ providedIn: "root" })
export class InnovationTypeService{

    /**
     * 
     * @param _http 
     */
    constructor(private _http: HttpClient){}

    /**
     * Get all Innovations Types
     * 
     */
    getAll(){
        return this._http.get<InnovationType[]>(`${environment.innovationApiUrl}/api/innovation-type`);
    }

}
